import React, { useMemo } from 'react';
const Image = (props) => {
    const { src, desktopsrc, tabletsrc, mobilesrc, mobilesmallsrc, image_alt, className, avoidLazy, avoidMedia } = props;
    const srcset = useMemo(() => {
        return `${mobilesmallsrc} 360w, ${mobilesrc} 768w, ${tabletsrc} 1024w, ${desktopsrc} 1571w`;
    }, [mobilesmallsrc, tabletsrc, mobilesrc]);
    return (React.createElement("picture", { className: className },
        React.createElement("source", Object.assign({ srcSet: srcset }, (!avoidMedia && { media: "(min-width: 768px)" }), { "data-srcset": srcset })),
        React.createElement("img", { alt: image_alt, src: src, loading: avoidLazy ? 'eager' : 'lazy' })));
};
export default Image;
